import { localize } from "utils/localizer";

const i18n = {
    acceptContracts: {
        en: "I have read and understood the contract and agreements.",
        de: "Ich habe die Vertragsbedingungen gelesen und akzeptiert.",
    },
    alreadyAccepted: {
        en: "The contract and agreements have already been accepted.",
        de: "Die Vertragsbedingungen wurden bereits akzeptiert.",
    },
    back: {
        en: "Back",
        de: "Zurück",
    },
    contactOwner: {
        en: "The following steps can only be accomplished by the location owner.",
        de: "Die folgenden Schritte können nur vom Eigentümer der Sportstätte vorgenommen werden.",
    },
    contracts: {
        en: "Contracts",
        de: "Vertragliches",
    },
    contractsRequired: {
        en: "The following contracts apply when using PLAYSPORTS:",
        de: "Folgende Verträge liegen der Nutzung von PLAYSPORTS zugrunde:",
    },
    finish: {
        en: "Finish",
        de: "Fertig",
    },
    firstHello: {
        en: "A first hello",
        de: "Ein erstes Hallo",
    },
    identityVerification: {
        en: "Identity Verification",
        de: "Identitätsprüfung",
    },
    identityVerificationSkipped: {
        en: "You already verified your identity in another location.",
        de: "Du hast deine Identität bereits in einer anderen Sportstätte bestätigt.",
    },
    identityVerificationDesc: {
        en: {
            failed: (reason: string) => `Unfortunately, your identity verification was unsuccessful: ${reason} Please try again and contact us if the problem persists.`,
            none: "Before you have access to the admin area, we need to verify your identity. Click on \"Next\" to proceed at our partner Stripe.",
            processing: "Your identity verification is being processed. If this takes longer than a couple of minutes, please reload the page or contact us.",
        },
        de: {
            failed: (reason: string) => `Leider war deine Identitätsprüfung nicht erfolgreich: ${reason} Bitte versuche es erneut und nimm Kontakt zu uns auf, falls das Problem weiterhin besteht.`,
            none: "Bevor du Zugriff auf den Admin-Bereich erhältst, müssen wir deine Identität überprüfen. Mit einem Klick auf \"Weiter\" gelangst du dafür zu unserem Partner Stripe.",
            processing: "Deine Identitätsprüfung wird aktuell durchgeführt. Sollte dies länger als ein paar Minuten dauern, lade die Seite bitte neu oder nimm Kontakt zu uns auf.",
        },
    },
    identityVerificationFailedReasons: {
        en: {
            document_expired: "The document has expired.",
            document_invalid: "The image supplied was not a valid document.",
            no_document_face: "No face was detected in the identity document image we collected.",
            no_face_match: "We detected faces in the identity document and in the selfie images but those faces did not match.",
            no_selfie_face: "No face was detected in the selfie image we collected.",
            scan_corrupt: "The document uploaded was invalid, and is likely corrupted. Please try uploading a new image.",
            scan_failed_copy: "The document supplied was not readable because it was a copy of the original document.",
            scan_failed_grayscale: "Scan failed.",
            scan_id_type_not_supported: "The document type is not supported.",
            scan_manipulated_document: "The document supplied was damaged or manipulated.",
            scan_missing_back: "The document supplied was not readable because the back of the document was not provided.",
            scan_not_readable: "The document supplied was not readable. It may have been too blurry or not well lit.",
            several_selfie_faces: "More than one face was detected in the selfie image we collected.",
            unexpected_document_country: "The identity document we collected was not from one of the allowed issuing countries.",
            unexpected_document_type: "The identity document we collected was not one of the allowed document types.",
        },
        de: {
            document_expired: "Das Dokument ist abgelaufen.",
            document_invalid: "Das Bild enthält kein gültiges Dokument.",
            no_document_face: "Es konnte kein Gesicht auf dem Dokument erkannt werden.",
            no_face_match: "Das Gesicht im Dokument stimmt nicht mit dem erstellten Selfie überein.",
            no_selfie_face: "Auf dem Selfie wurde kein Gesicht erkannt.",
            scan_corrupt: "Das hochgeladene Dokument ist ungültig oder beschädigt. Bitte lade ein neues Bild hoch.",
            scan_failed_copy: "Das hochgeladene Dokument ist nur eine Kopie des Originals.",
            scan_failed_grayscale: "Scan fehlgeschlagen.",
            scan_id_type_not_supported: "Die verwendete Dokumentart wird nicht unterstützt.",
            scan_manipulated_document: "Das hochgeladene Dokument ist beschädigt oder gefälscht.",
            scan_missing_back: "Das bereitgestellte Dokument war nicht lesbar, da die Rückseite des Dokuments nicht bereitgestellt wurde.",
            scan_not_readable: "Das mitgelieferte Dokument war nicht lesbar. Es war möglicherweise zu verschwommen oder nicht gut beleuchtet.",
            several_selfie_faces: "Im hochgeladenen Selfie wurde mehr als ein Gesicht erkannt.",
            unexpected_document_country: "Das Ausweisdokument stammt nicht aus einem der zugelassenen Ausstellungsländer.",
            unexpected_document_type: "Das Ausweisdokument ist keins der zulässigen Dokumentenarten.",
        },
    },
    next: {
        en: "Next",
        de: "Weiter",
    },
    retry: {
        en: "Retry",
        de: "Wiederholen",
    },
    welcome: {
        en: "Welcome",
        de: "Willkommen",
    },
};

export default localize(i18n);
